import styled from "styled-components";
import { CardBody } from "shards-react";

export const CustomizedCardBody = styled(CardBody)`
    width: 100%;
`;
export const SpanMessage = styled.span`
    display: block;
    text-align: center;
    font-style: italic;
    color: var(--neutralcolor-dark);
`;
export const SubTitle = styled.h6`
    color: var(--neutralcolor-darkest);
`;

export const CustomizedTd = styled.td`
    color: var(--neutralcolor-dark);
    display: flex;
`;
export const ButtonAsLink = styled.button`
    background: none !important;
    outline: none !important;
    border: none;
    padding: 0 !important;
    color: var(--managercolor-secondary-light);
    text-decoration: none;
    cursor: pointer;
    &:hover {
        color: var(--managercolor-secondary-dark);
    }
`;

export const ButtonAsLinkPrimary = styled.button`
    background: none !important;
    outline: none !important;
    border: none;
    padding: 0 !important;
    color: var(--managercolor-secondary-dark);
    text-decoration: none;
    cursor: pointer;
    &:hover {
        color: var(--managercolor-secondary-light);
    }
`;

export const ButtonConatiner = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
`;
export const FetchingText = styled.span`
    display: block;
    color: var(--neutracolor-brand-darkest);
    font-size: 0.975em;
    text-align: center;
    padding: 20px;
`;

export const KeyContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 43%;
    padding: 10px;
    align-items: flex-start;
`;
export const KeyTitle = styled.span`
    color: var(--neutralcolor-dark);
    font-size: 1em;
    font-weight: 600;
    letter-spacing: 0.3px;
`;
export const KeyText = styled.span`
    color: var(--neutralcolor-dark);
    font-size: 1em;
    letter-spacing: 0.3px;
`;

export const AccessKeyCode = styled.code`
    color: crimson;
    background-color: #f1f1f1;
`;
